export default __webpack_public_path__ + "static/media/logo-app2n.7d45f122.svg";